"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreFunctionalTabs = require("@legacy-vfuk/core-functional-tabs");
var _coreOverflowMenu = require("@legacy-vfuk/core-overflow-menu");
var _coreBaseProps = require("@legacy-vfuk/core-base-props");
var _coreThemes = require("@legacy-vfuk/core-themes");
var _Tabs = _interopRequireDefault(require("./themes/Tabs.theme"));
var Styled = _interopRequireWildcard(require("./styles/Tabs.style"));
var _TabTitle = _interopRequireDefault(require("./components/TabTitle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Tabs = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tabs, _PureComponent);
  var _super = _createSuper(Tabs);
  function Tabs() {
    var _this;
    _classCallCheck(this, Tabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.componentName = 'Tabs';
    _this.state = {
      overflowActive: false,
      activeTabId: _this.props.externallySetTabId || '',
      maxWidthOfTabList: 0,
      isOverflowMenuOpen: false
    };
    _this.tabsListRef = /*#__PURE__*/_react["default"].createRef();
    _this.overflowMenuRef = /*#__PURE__*/_react["default"].createRef();
    _this.setOverflowActive = function () {
      var _this$tabsListRef;
      // Checks the tab size against the maximum allowed size (viewable area) of the tabs container.
      // If it would overflow then we need to show the dropdown version
      var tableList = (_this$tabsListRef = _this.tabsListRef) === null || _this$tabsListRef === void 0 ? void 0 : _this$tabsListRef.current;
      if (tableList) {
        // Here we set the width equal to the sum of all elements, if we have not already set it
        if (tableList.scrollWidth > tableList.offsetWidth && !_this.state.overflowActive && !_this.state.maxWidthOfTabList) {
          var maxWidthOfTabList = Array.from(tableList.children).reduce(function (previousValue, currentValue) {
            return previousValue + currentValue.offsetWidth;
          }, 0);
          _this.setState({
            maxWidthOfTabList: maxWidthOfTabList
          });
        }
        // If the maxWidthOfTabList is not set, then scrollWidth is compared with offsetWidth
        _this.setState({
          overflowActive: _this.isOverflowActive(tableList)
        });
      }
    };
    _this.getActiveTab = function () {
      var activeTab = _this.props.children.find(function (tab) {
        return tab.props.id === _this.state.activeTabId;
      });
      return activeTab || _this.props.children[0];
    };
    _this.setisOverflowMenuOpen = function () {
      _this.setState({
        isOverflowMenuOpen: !_this.state.isOverflowMenuOpen
      });
    };
    _this.handleChangeOverflowMenu = function (value) {
      _this.setState({
        activeTabId: value
      });
    };
    _this.handleCloseOverflowMenu = function () {
      _this.setState({
        isOverflowMenuOpen: false
      });
    };
    _this.handleTabTitleOnClick = function (tabId) {
      return function () {
        _this.setState({
          activeTabId: tabId
        });
      };
    };
    _this.handleTabTitleOnKeyPress = function (tabId) {
      return function (event) {
        if (event.key === 'Enter') {
          _this.setState({
            activeTabId: tabId
          });
        }
      };
    };
    return _this;
  }
  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setOverflowActive();
      window.addEventListener('resize', this.setOverflowActive);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setOverflowActive);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.externallySetTabId !== prevProps.externallySetTabId && this.props.externallySetTabId !== this.state.activeTabId) {
        this.setState({
          activeTabId: this.props.externallySetTabId
        });
      }
    }
  }, {
    key: "isOverflowActive",
    value: function isOverflowActive(element) {
      if (this.state.maxWidthOfTabList) {
        return this.state.maxWidthOfTabList > element.offsetWidth;
      }
      return element.offsetWidth < element.scrollWidth;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var overflowActiveTabTitle = this.state.overflowActive && this.getActiveTab();
      return /*#__PURE__*/_react["default"].createElement(_coreFunctionalTabs.FunctionalTabs, {
        onTabClick: this.props.onTabClick,
        externallySetTabId: this.state.activeTabId,
        accessibilityInfiniteScroll: this.props.accessibilityInfiniteScroll,
        id: this.props.id,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        componentName: this.componentName,
        dataAttributes: this.props.dataAttributes
      }, /*#__PURE__*/_react["default"].createElement(Styled.TabListContainer, {
        tabsTheme: this.props.localTheme,
        appearance: this.props.appearance,
        inverse: this.props.inverse
      }, /*#__PURE__*/_react["default"].createElement(Styled.TabList, {
        ref: this.tabsListRef,
        overflowActive: this.state.overflowActive,
        role: "tablist",
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'tab-list')
      }, this.state.overflowActive ? /*#__PURE__*/_react["default"].createElement(Styled.TabTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_TabTitle["default"], {
        tabWidth: this.props.tabs.width,
        tabId: overflowActiveTabTitle.props.id,
        isActiveTab: overflowActiveTabTitle.props.isActiveTab,
        appearance: this.props.appearance,
        inverse: this.props.inverse,
        text: overflowActiveTabTitle.props.text,
        onClick: this.setisOverflowMenuOpen,
        overflowActive: this.state.overflowActive,
        isOverflowMenuOpen: this.state.isOverflowMenuOpen,
        localTheme: this.props.localTheme,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'tab-title')
      }), /*#__PURE__*/_react["default"].createElement(Styled.OverflowMenuContainer, null, /*#__PURE__*/_react["default"].createElement(_coreOverflowMenu.OverflowMenu, {
        isOpen: this.state.isOverflowMenuOpen,
        onChange: this.handleChangeOverflowMenu,
        activeItem: this.state.activeTabId || this.props.children[0].props.id,
        onClose: this.handleCloseOverflowMenu,
        triggerRef: this.overflowMenuRef,
        onOutsideClick: this.handleCloseOverflowMenu,
        srText: overflowActiveTabTitle.props.text,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'overflow-menu')
      }, _react["default"].Children.map(this.props.children, function (child, key) {
        return /*#__PURE__*/_react["default"].createElement(_coreOverflowMenu.OverflowMenuItem, {
          key: key,
          value: child.props.id,
          text: child.props.text,
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this2.props.dataSelectorPrefix, "menu-item-".concat(key))
        });
      })))) : _react["default"].Children.map(this.props.children, function (child, key) {
        return /*#__PURE__*/_react["default"].createElement(_TabTitle["default"], {
          key: key,
          tabWidth: _this2.props.tabs.width,
          tabId: child.props.id,
          isActiveTab: child.props.isActiveTab,
          appearance: _this2.props.appearance,
          inverse: _this2.props.inverse,
          text: child.props.text,
          onClick: _this2.handleTabTitleOnClick(child.props.id),
          onKeyPress: _this2.handleTabTitleOnKeyPress(child.props.id),
          localTheme: _this2.props.localTheme,
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this2.props.dataSelectorPrefix, "tab-title-".concat(key))
        });
      }))), this.props.children);
    }
  }]);
  return Tabs;
}(_react.PureComponent);
Tabs.defaultProps = {
  appearance: 'primary',
  inverse: false,
  tabs: {
    width: 'fit'
  }
};
Tabs.displayName = "Tabs";
var _default = (0, _coreThemes.withLocalTheme)(Tabs, _Tabs["default"]);
exports["default"] = _default;
//# sourceMappingURL=Tabs.js.map